import React from 'react';
import '../styles/loaderAnimation.css';

function SoftLoader() {
  return (
    <div className='light-loader-bg'>
        <div className="bubble"></div>
        <div className="bubble"></div>
        <div className="bubble"></div>
        <div className="bubble"></div>
        <div className="bubble"></div>
        <div className="bubble"></div>
    </div>
    );
}

export default SoftLoader;
